export default __webpack_public_path__ + "static/media/retirement.3dd4f6a6.png";